<template>
  <div>
    <div class="fullscreen-modal__content">
      <page>
        <page-title>
          {{ $t('c.mailingOverlay.stepArticles.title') }}
        </page-title>

        <div class="mailing__topbar">
          <div class="mailing__topbar--left">
            <switch-input
              v-model="groupByTags"
              :label-visible="false"
              hint="Artikel nach Tags gruppieren"
              name="groupByTags"
              direction="vertical"
            />
          </div>
          <div class="mailing__topbar--right">
            <div class="content__dropdown-wrap">
              <dropdown-input
                :options="selectDropdownOptions"
                theme="primary"
                position="right"
                @select="handleSelectDropdownSelect"
              >
                <button-input>
                  <font-awesome-icon icon="toggle-on" />
                  <font-awesome-icon icon="angle-down" />
                </button-input>
              </dropdown-input>
            </div>
          </div>
        </div>

        <div
          v-if="groupByTags"
        >
          <div
            v-for="tag in selectedTags"
            :key="tag.id"
          >
            <div class="list-group">
              <div class="list-group__name">#{{ tag.name }}</div>
              <div class="list-group__selected">
                {{ $tc('c.mailingOverlay.stepArticles.groupedContentSelected', groupedContentSelected(tag).length, {count: groupedContentSelected(tag).length}) }}
              </div>
            </div>
            <div
              class="articles-list"
            >
              <draggable
                :value="tag.contents"
                :options="dragOptions"
                @input="contents => setTagContents({tag, contents})"
                @start="drag=true"
                @end="drag=false"
              >
                <list-item
                  v-for="content in tag.contents"
                  :key="content.id"
                  :title="content.title"
                  :href="content.href"
                  :subline="tag.body"
                  :sortable="true"
                  :clickable="true"
                  :switch-name="tag.slug + content.id"
                  :switch-value="isContentSelected({tag, content})"
                  @switch-input="selectContent({tag, content})"
                  @on-click="openContent(content)"
                />
              </draggable>
            </div>
          </div>
        </div>

        <div
          v-else
          class="articles-list"
        >
          <draggable
            :value="contents"
            :options="dragOptions"
            @input="contents => setContents(contents)"
            @start="drag=true"
            @end="drag=false"
          >
            <list-item
              v-for="content in contents"
              :key="content.id"
              :title="content.title"
              :title-clickable="true"
              :subline="content.tags"
              :sortable="true"
              :switch-name="content.id"
              :switch-value="isContentSelected({content})"
              @switch-input="selectContent({content})"
              @on-click="openContent(content)"
            />
          </draggable>
        </div>
      </page>
    </div>
    <div class="fullscreen-modal__footer">
      <div class="container">
        <div class="row">
          <div class="col-xs-6 col-lg-4 push-lg-2">
            <button-input
              v-t="'c.mailingOverlay.stepArticles.btnNext'"
              :is-disabled="stepIsInvalid"
              @click="nextStep"
            />
          </div>

          <div class="col-xs-6 col-lg-4 push-lg-2 text-right">
            <button-input
              v-t="'c.mailingOverlay.stepArticles.btnBack'"
              color="grey"
              @click="prevStep"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import PageMixin from '@/mixins/pages/Page'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import draggable from 'vuedraggable'
import ListItem from '@/components/ui/ListItem'

export default {
  mixins: [FormMixin, PageMixin],
  components: {
    FontAwesomeIcon,
    ListItem,
    draggable
  },
  computed: {
    ...mapState ({
      groupedContent: state => state.mailing.entry.data,
      contents: state => state.mailing.entry.contents,
      selected: state => state.mailing.entry.selected.content,
      groupByTags: state => state.mailing.entry.groupByTags
    }),
    ...mapGetters ({
      isContentSelected: 'mailing/entry/isContentSelected',
      selectedContent: 'mailing/entry/selectedContent',
      selectedTags: 'mailing/entry/selectedTags',
      groupedContentSelected: 'mailing/entry/groupedContentSelected'
    }),
    selectDropdownOptions () {
      return [
        { label: 'Alle auswählen', value: 'selectall', icon: 'toggle-on' },
        { label: 'Alle abwählen', value: 'deselectall', icon: 'toggle-off' }
      ]
    },
    dragOptions () {
      return {
        handle: '.list-item__handle'
      }
    },
    stepIsInvalid () {
      return this.selectedContent.length === 0
    },
    groupByTags: {
      get () { return this.$store.state.mailing.entry.groupByTags },
      set (value) { this.$store.dispatch('mailing/entry/setGroupByTags', value) }
    }
  },
  methods: {
    ...mapActions ({
      selectContent: 'mailing/entry/selectContent',
      setContents: 'mailing/entry/setContents',
      setTagContents: 'mailing/entry/setTagContents',
      selectAllContents: 'mailing/entry/selectAllContents',
      prevStep: 'mailing/step/prev',
      nextStep: 'mailing/step/next'
    }),
    openContent (content) {
      window.open(content.href, '_blank')
    },
    handleSelectDropdownSelect ({ value }) {
      switch (value) {
        case 'selectall':
          this.selectAllContents(true)
          break
        case 'deselectall':
          this.selectAllContents(false)
          break
        default:
          window.alert(`action: ${value}`)
      }
    }
  }
}
</script>

<style lang="sass">
@import '~styles/imports'

.controls
  display: flex
  flex-direction: row
  justify-content: flex-end
  align-items: center
  margin-bottom: 30px

  &__dropdown-wrap
    margin-left: 10px

.list-group
  margin-bottom: rem-calc(20)
  display: flex
  align-items: center
  color: #9CABA8

  &__name
    @include font-size(12, 16)
    font-weight: 700
    display: inline-block
    // border: 1px solid #e1e5ea
    padding: rem-calc(10 20)
    margin-right: rem-calc(30)
    color: #fff
    background: #000

  &__selected
    @include font-size(12, 16)

.articles-list
  border-top: 1px solid #e1e5ea
  margin-bottom: rem-calc(60)

  &__item
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: center
    height: 100px
    font-size: 22px
    border-bottom: 1px solid #e1e5ea

  &__title
    font-weight: 600

</style>




// WEBPACK FOOTER //
// src/components/mailings/steps/Articles.vue